export default __webpack_public_path__ + "static/media/smiles.badb63c9.svg";